import React, { useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Icon } from '@iconify/react';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useNavigate } from 'react-router-dom';

import 'react-tooltip/dist/react-tooltip.css';

import './PropostaList.scss';

function CategoriasList({ categorias, showModalCategoriasDelete, showModalCategoriasEdit }) {

    const navigate = useNavigate();

    const paginatorTemplate = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        CurrentPageReport: (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} de {options.totalRecords}
                </span>
            );
        }
    };

    useEffect(() => {
        if (categorias) {
            console.log("categorias", categorias);
        }
    }, [categorias]);

    return (
        <>
            <div className="UsuariosList">
                <div className="card">
                    <DataTable
                        value={categorias}
                        paginatorClassName={"paginator"}
                        paginatorTemplate={paginatorTemplate}
                        sortField="createdAt"
                        sortOrder={-1}
                        paginator
                        rows={12}>

                        <Column
                            field="status"
                            header="STATUS"
                            style={{ width: '14%' }}
                            bodyClassName="status-column"
                            body={(rowData) => {
                                if (rowData.status === 0) {
                                    return <span><i></i> <strong>Inativo</strong></span>;
                                } else if (rowData.status === 1) {
                                    return <span><i></i> <strong>Ativo</strong></span>;
                                }
                                return <span><i></i> <strong>Ativo</strong></span>;
                            }}>
                        </Column>


                        <Column field="codigo"
                            header="CÓDIGO"
                            bodyClassName="title-column code-column"
                            style={{ width: '20%' }} >
                        </Column>

                        <Column field="nome"
                            header="NOME"
                            bodyClassName="title-column name-column"
                            style={{ width: '20%' }} >
                        </Column>

                        <Column field="modelo"
                            header="MODELO"
                            bodyClassName="title-column model-column"
                            style={{ width: '20%' }} >
                        </Column>



                        <Column
                            field="Actions"
                            header="AÇÕES"
                            style={{ width: '22%' }}
                            bodyClassName="actions-column"
                            body={(rowData) => {
                                return (
                                    <>
                                        <button className='Btns ButtonIcon' onClick={() => showModalCategoriasDelete(rowData.id)}>
                                            <i><Icon className="icons" icon="mdi:trash" /></i>
                                        </button>
                                        <button className='Btns ButtonIcon' onClick={() => navigate(`/proposta/imprimir/${rowData.id}`)}>
                                            <i><Icon className="icons" icon="ri:printer-line" /></i>
                                        </button>
                                        <button className='Btns View' onClick={() => navigate(`/proposta/editar/${rowData.id}`)}>
                                            Editar <i><Icon className="icons" icon="ri:add-fill" /></i>
                                        </button>
                                        
                                    </>
                                );
                            }}
                        ></Column>
                    </DataTable>
                </div>
            </div>
            <ReactTooltip id="my-tooltip-1" place="bottom" content="Publicar" />
            <ReactTooltip id="my-tooltip-2" place="bottom" content="Já publicado" />
        </>
    );
}

export default CategoriasList;
